import axiosInstance from '../axios';
import endpoints from '../endpoints';

const userService = {
  // Get all users (Super Admin)
  getAllUsers: async (params = {}) => {
    try {
      // Start with a simple request to test
      console.log('getAllUsers called with params:', params);
      
      const response = await axiosInstance.get(endpoints.users.list);
      console.log('Response received:', response.data);
      
      return response.data;
    } catch (error) {
      console.error('getAllUsers error:', error);
      console.error('Error response:', error.response?.data);
      throw error;
    }
  },

  // Get user by ID (Super Admin)
  getUserById: async (userId) => {
    const response = await axiosInstance.get(`${endpoints.users.list}/${userId}`);
    return response.data;
  },

  // Approve user (Super Admin)
  approveUser: async (userId) => {
    const response = await axiosInstance.put(endpoints.users.approve(userId));
    return response.data;
  },

  // Reject user (Super Admin)
  rejectUser: async (userId, reason) => {
    if (!reason || reason.trim() === '') {
      throw new Error('Rejection reason is required');
    }
    const response = await axiosInstance.put(endpoints.users.reject(userId), { reason });
    return response.data;
  },

  // Delete user (Super Admin)
  deleteUser: async (userId) => {
    const response = await axiosInstance.delete(`${endpoints.users.list}/${userId}`);
    return response.data;
  },

  // Get pending approvals count
  getPendingCount: async () => {
    const response = await axiosInstance.get(`${endpoints.users.list}/pending/count`);
    return response.data;
  }
};

export default userService;